export const SET_CONTACT_INDEX = 'SET_CONTACT_INDEX'
export const SET_STEP_INDEX = 'SET_STEP_INDEX'
export const GET_MERCHAT_INFO = 'GET_MERCHAT_INFO'
export const SET_APPLY_STATUS = 'SET_APPLY_STATUS'
export const LOGIN_STATUS = 'LOGIN_STATUS'
export const GET_ADDRESS_INFO = 'GET_ADDRESS_INFO'
export const GET_BRAND_INFO = 'GET_BRAND_INFO'
export const SET_ISADMIN = 'SET_ISADMIN' // 设置账号是否为主账号
export const SET_ISTATIONED = 'SET_ISTATIONED' // 设置账号是否入驻成功
export const SET_ISOVERSEAS = 'SET_ISOVERSEAS' // 设置是否海淘商家
export const SET_ENTER_STATE = 'SET_ENTER_STATE' // 设置入驻状态
export const SET_SIGN_STATE = 'SET_SIGN_STATE' // 设置合作协议签署状态
export const SET_SIGN_DATA = 'SET_SIGN_DATA' // 设置签署数据
export const SET_OPERATION_LOG = 'SET_OPERATION_LOG' // 设置操作时间
export const SET_MERCHANT_DATA = 'SET_MERCHANT_DATA' // 设置入驻信息
export const SET_REVIEW_DURATION = 'SET_REVIEW_DURATION' // 设置审批已用时间（小时）
export const SET_APPLICATION_ID = 'SET_APPLICATION_ID' // 设置审批时间
